import { useEffect, useState } from "react";
import { listCampaignImportOrganizations } from "../api";

interface CampaignImportOrganization {
  id: string;
  name: string;
  state: string | null;
}

interface UseCampaignImportOrganizationsResult {
  organizations: CampaignImportOrganization[];
}

export function useCampaignImportOrganizations(enabled: boolean): UseCampaignImportOrganizationsResult {
  const [organizations, setOrganizations] = useState<CampaignImportOrganization[]>([]);

  useEffect(() => {
    if (!enabled) {
      setOrganizations([]);
      return;
    }

    void listCampaignImportOrganizations().then(setOrganizations).catch(() => setOrganizations([]));
  }, [enabled]);

  return { organizations };
}
